import { useState, useEffect } from "react";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";

// One cached promise per context — fetched at most once per app session.
const cache = {};

function loadConfig(context) {
  if (!cache[context]) {
    const query =
      context !== "general" ? `?context=${encodeURIComponent(context)}` : "";
    cache[context] = backendGet(`data/anlages/config${query}`)
      .then((data) => data ?? null)
      .catch(() => {
        delete cache[context]; // allow retry on network error
        return null;
      });
  }
  return cache[context];
}

/**
 * Returns the list of allowed upload extensions for the given context
 * (defaults to 'general'). Returns null while the first fetch is in flight;
 * subsequent calls with the same context resolve from the module-level cache.
 *
 * @param {'general'|'cost'|string} [context='general']
 */
export function useAttachmentConfig(context = "general") {
  const [extensions, setExtensions] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadConfig(context).then((data) => {
      if (!cancelled && data?.allowed_extensions) {
        setExtensions(data.allowed_extensions);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [context]);

  return extensions;
}
